/* My Wild — Black November (28/10/2026)
   Countdown (<mw-bn-countdown>) e animazione dei badge. Legge date e stato da window.mwBN,
   scritto dalla sezione mw-black-november-barra nel gruppo Header. */
(function () {
  if (window.mwBNjs) return;
  window.mwBNjs = true;
  var B = window.mwBN;
  if (!B) return;
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- countdown ----------
     data-breve: scrive "3g 04:12:33" dentro [data-breve-out].
     Altrimenti aggiorna [data-k="d|h|m|s"] e l'etichetta [data-lbl] con data-lbl-durante/fine. */
  if (!customElements.get('mw-bn-countdown')) {
    customElements.define('mw-bn-countdown', class extends HTMLElement {
      connectedCallback() {
        this.last = {};
        this.tick();
        this.timer = setInterval(this.tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        var d = this.dataset, now = B.now(), st = B.stato(now), target = 0, lbl = '';
        if (st === 'pre') { target = B.inizio; }
        else if (st === 'on') { target = B.fine; lbl = d.lblDurante; }
        else { lbl = d.lblFine; this.classList.add('is-finito'); clearInterval(this.timer); }
        var r = target ? Math.max(0, target - now) : 0;
        var v = { d: Math.floor(r / 864e5), h: Math.floor(r / 36e5) % 24, m: Math.floor(r / 6e4) % 60, s: Math.floor(r / 1e3) % 60 };

        var out = this.querySelector('[data-breve-out]');
        if (out) out.textContent = (v.d ? v.d + 'g ' : '') + pad(v.h) + ':' + pad(v.m) + ':' + pad(v.s);

        var l = this.querySelector('[data-lbl]');
        if (l && lbl) l.textContent = lbl;

        var self = this;
        ['d', 'h', 'm', 's'].forEach(function (k) {
          var el = self.querySelector('[data-k="' + k + '"]');
          if (!el) return;
          var txt = pad(v[k]);
          if (self.last[k] === txt) return;
          self.last[k] = txt;
          el.textContent = txt;
          el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick');
        });

      }
    });
  }

  /* ---------- badge: entrano e la percentuale sale da 0 quando la scheda diventa visibile ----------
     Funziona anche con lo scorrimento infinito e i filtri (schede aggiunte dopo). */
  var html = document.documentElement;
  if (!html.classList.contains('mw-bn-on') || !('IntersectionObserver' in window)) return;

  function conta(el) {
    var m = el.textContent.match(/(\d+)/);
    el.classList.add('is-entrato');
    if (!m || calmo) return;
    var fine = +m[1], t0 = performance.now(), dur = 900;
    (function passo(t) {
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = '-' + Math.round(fine * e) + '%';
      if (p < 1) requestAnimationFrame(passo);
    })(t0);
  }
  var io = new IntersectionObserver(function (voci) {
    voci.forEach(function (v) {
      if (!v.isIntersecting) return;
      io.unobserve(v.target);
      conta(v.target);
    });
  }, { threshold: 0.6 });
  function cerca(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('.mw-bn-badge:not([data-mw-bn-visto])').forEach(function (el) {
      el.setAttribute('data-mw-bn-visto', '');
      io.observe(el);
    });
  }
  cerca(document);
  new MutationObserver(function (ms) {
    ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) cerca(n); }); });
  }).observe(document.body, { childList: true, subtree: true });
})();
